import {
  SET_SEARCH_ACTIVE,
} from 'shared/searchBarActions';

export default function resultsReducer(state = false, action) {
  switch (action.type) {
  case SET_SEARCH_ACTIVE:
    return !!action.payload.active;
  default:
    return state;
  }
}
